<template>
  <div class="container">
    <md-progress-bar md-mode="query" class="md-accent" v-if="loading"></md-progress-bar>
    
    <div class="md-layout-item md-size-100" v-else>

      <span class="md-title">{{$t('games.list.title')}}</span>
      <md-toolbar class="filters md-transparent" md-elevation="0">
        <!-- <h3 class="md-title" style="flex: 1">Filtros</h3> -->
        <div class="md-toolbar-section-end">
          <md-field class="md-layout-item md-size-20">
            <label>{{$t('games.list.filter.like')}}</label>
            <md-input v-model="filters.like"></md-input>
          </md-field>
          <!-- Temporada -->
          <md-field class="md-layout-item md-size-20">
            <label>{{$t('games.list.filter.season')}}</label>
            <md-select v-model="filters.seasonId" name="season" id="season">
              <md-option v-for="season in listSeasons" :key="season.id" :value="season.id">{{season.name}}</md-option>
            </md-select>
          </md-field>
          <!-- Fecha -->
          <md-field class="md-layout-item md-size-20">
            <label>{{$t('games.list.filter.matchday')}}</label>
            <md-input v-model="filters.matchday" type="number"></md-input>
          </md-field>
        </div>
      </md-toolbar>

      <md-table md-card>
        <md-table-row>
          <md-table-head>{{$t('games.list.game')}}</md-table-head>
          <md-table-head>{{$t('games.list.stadium')}}</md-table-head>
          <md-table-head>{{$t('games.list.date')}}</md-table-head>
          <md-table-head>{{$t('games.list.status')}}</md-table-head>
          <md-table-head>{{$t('games.list.actions')}}</md-table-head>
        </md-table-row>

        <md-table-row v-for="game in listGames" :key="game.id">
          <md-table-cell>{{ game.local.name }} vs {{ game.visitor.name }}</md-table-cell>
          <md-table-cell>{{ game.stadium.name }}</md-table-cell>
          <md-table-cell>{{ formatDate(game.scheduledMatchDate) }}</md-table-cell>
          <md-table-cell>
            <badge :type="game.publishDate !== null ? 'success': 'danger'">
              {{ game.publishDate !== null ? $t('games.list.publish') : $t('games.list.unpublish') }}
            </badge>
          </md-table-cell> 
          <md-table-cell>
            <md-button class="md-info" :to="`/game/edit/${game.id}`">
              {{$t('games.list.edit')}}
            </md-button>
            <md-button class="md-success" :to="`/game/manage/${game.id}`">
              {{$t('games.list.manage')}}
            </md-button>
          </md-table-cell>
        </md-table-row>
      </md-table>
      <pagination
        v-if="totalGames > 20"
        v-model="pageActual"
        :page-count="(totalGames / 20)">
      </pagination>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import moment from 'moment';
import {Pagination, Badge} from '@/components'

export default {
  components: {
    Pagination,
    Badge
  },
  data() {
    return {
      pageActual: 1,
      filters: {
        like: '',
        seasonId: null,
        matchday: null
      },
      // filterLike: '',
      loading: true
    }
  },
  computed: {
    ...mapState({
      listGames: state => state.GameModule.listGames,
      totalGames: state => state.GameModule.totalGames,
      listSeasons: state => state.StuffModule.seasons
    })
  },
  mounted() {
    this.search()
    if (this.listSeasons.length == 0) this.$store.dispatch('seasonsGet')
  },
  methods: {
    formatDate(date) {
      return moment(date).format("DD/MM/YYYY HH:mm")
    },
    search(forceLoading = true) {
      if (forceLoading) this.loading = true
      this.$store.dispatch('search', {filters: this.filters, pageNumber: (this.pageActual - 1)})
        .then(() => {
          if(forceLoading) this.loading = false
        })
    }
  },
  watch: {
    pageActual() {
      this.search(false)
    },
    'filters.like': function() { this.search(false) },
    'filters.seasonId': function() { this.search(false) },
    'filters.matchday': function() { this.search(false) }
  }
}
</script>

<style lang="scss">
  .md-toolbar.filters {
    padding : 0;

    .md-layout-item {
      margin: 0 12px;
    }
  }
</style>